import { defineMessages } from 'react-intl';

const messages = defineMessages({
  VatPeriodicity: 'VAT periodicity',
  ShowInvoiceHistory: 'Show invoice history',
  EmptyVATPeriodicity: 'Without VAT periodicity',
  ToInvoice: 'To invoice',
  Relation: 'Relation',
  RelationCode: 'Relation code',
  Edit: 'Edit',
  Assignment: 'Assignment',
  MergeWith: 'Merge with',
  Amount: 'Amount',
  Hours: 'Hours',
  Distance: 'Distance',
  InvoicingType: 'Invoicing type',
  NextScheduleDate: 'Next schedule date',
  NoInvoicingSchedule: 'No schedule',
  RemoveRegistration: 'Remove registration',
  RemoveRegistrationConfirmationMsg:
    'Are you sure you want to remove this registration? It will be permanently deleted.',
  RegistrationMarkedAsNeverInvoice: 'Registration marked as never invoice',
  NeverInvoiceRegistration: 'Never invoice registration',
  NeverInvoiceRegistrationConfirmationMsg:
    'Are you sure you want to mark this registration as "Never invoice"? The registration will not be deleted, but can only be invoiced from the registration overview.',
  RegistrationAddedToInvoiceProposal: 'Registration added to invoice proposal',
  RegistrationRemoved: 'Registration removed',
  Actions: 'Actions',
  Totals: 'Totals',
  MakeInvoiceProposal: 'Make invoice proposal',
  AddToInvoiceProposal: 'Add to invoice proposal',
  LockRegistration: 'Lock registration',
  LockRegistrations: 'Lock registrations',
  BatchLockRegistrations: 'Lock registrations',
  UnlockRegistration: 'Unlock registration',
  UnlockRegistrations: 'Unlock registrations',
  BatchUnlockRegistrations: 'Unlock registrations',
  InvoiceAllRegistrations: 'Invoice all registrations',
  InvoiceAllRegistrationsTooltip:
    'Link all open registrations to an invoice proposal. If an invoice proposal exists already, registrations will be added. If not, a new invoice proposal will be created.',
  ShowInRegistrationOverview: 'Show in registration overview',
  OpenInvoiceProposal: 'Open invoice proposal',
  TotalAmount: 'Total amount',
  TotalHours: 'Total hours',
  RegistrationAmount: 'Registration amount',
  RegistrationIncludedInForfait: 'Included in fixed amount',
  RegistrationExcludedFromForfait: 'Excluded from fixed amount',
  ForfaitAmount: 'Fixed amount',
  SelectOverviewColumns: 'Select overview columns',
  ColumnConfig: 'Configure columns',
  UnsettledAdvances: 'Unsettled advances',
  TotalToInvoiceAmount: 'Total to invoice',
  ToInvoiceAmount: 'To invoice amount',
  NrDraftInvoicedCreatedOrModified: '{nr} invoice proposals were created/changed',
  GlobalActions: 'Global actions',
  ToInvoiceGlobalActionsTooltip: 'Select one or more relations to execute a batch action.',
  LegalForms: 'Legal forms',
  Processing: 'Processing',
  ResetFilters: 'Reset filters',
  CountSelected: 'Selected {count} / {total}',
  NoDataFound: 'No data found',
  ExportToExcel: 'Export to Excel',
  Relations: 'Relations',
  HasInvoicingVia: 'Has invoicing via',
  FixedAmount: 'Fixed amount',
  RegistrationsUntil: 'Registrations until',
  InvoiceText: 'Invoice text',
  Number: 'Number',
  Date: 'Date',
  Advances: 'Advances',
  OpenPdf: 'Open pdf',
  OpenInvoiceOverview: 'Open invoice overview',
  Registrations: 'Registrations',
  Employee: 'Employee',
  Resource: 'Resource',
  Quantity: 'Quantity',
  UnitPrice: 'UnitPrice',
  InForfait: 'InForfait',
  Billable: 'Billable',
  Remark: 'Remark',
  InternalRemark: 'Internal remark',
  WithLabels: 'With labels',
  WithoutLabels: 'Without labels',
  RegisteredBy: 'Registered by',
  PriceListItem: 'Price list item',
  NoPriceListItemsFound: 'No price list item found',
  ReferenceYear: 'Reference year',
  WithoutReferenceYear: 'Without reference year',
  ExportToExcelStarted: 'Export to Excel started',
  FilterLockedRegistrationsAll: 'All',
  FilterLockedRegistrationsLocked: 'Locked registrations',
  FilterLockedRegistrationsUnlocked: 'Unlocked registrations',
  msgRegistrationIsLockedForEdit: 'The registration is locked and cannot be modified.',
  msgRegistrationIsLockedForDelete: 'The registration is locked and cannot be deleted.',
});
export default messages;
